/**
 * 回答欄クラス
 */
export default class EFOcats_answer {
  /**
   * 回答欄設置
   */
  set(tmp, answer, elem) {
    // 子クラスで実装する
  }

  /**
   * 属性取得
   * @param input
   * @param answer
   * @param elem
   */
  attr(input, answer, elem) {
    Object.keys(answer).forEach(key => {
      switch (key) {
        case 'data-required':
          if (answer[key] === '1') {
            elem.find('.container').addClass('required');
          }
          break;
        case 'attr':
          Object.keys(answer.attr).forEach(name_key => {
            input.setAttribute(name_key, answer[key][name_key]);
          });

          break;
        case 'value':
          break;
        case 'name':
          break;
        case 'type':
          if (answer.type !== 'select' && answer.type !== 'textarea') {
            input.setAttribute(key, answer[key]);
          }
          break;
        default:
          input.setAttribute(key, answer[key]);
      }
    });
  }
}
